import styled from 'styled-components'

const StyledPassword = styled.div`
  .change-password-input {
    display: flex;

    button {
      margin-left: 6px;
      width: 40px;
      flex-shrink: 0;
      border-radius: 4px;
      padding: 0;
      color: ${({ theme }) => theme.colors.gray[600]};
      border: 1px solid ${({ theme }) => theme.colors.gray[100]};
      background-color: ${({ theme }) => theme.colors.gray[100]};

      svg {
        margin: 0;
      }

      &:hover {
        border: 1px solid ${({ theme }) => theme.colors.gray[200]};
        background-color: ${({ theme }) => theme.colors.gray[200]};
      }

      &.save-btn {
        color: ${({ theme }) => theme.colors.background};
        border: 1px solid ${({ theme }) => theme.colors.green[500]};
        background-color: ${({ theme }) => theme.colors.green[500]};

        &:hover {
          border: 1px solid ${({ theme }) => theme.colors.green[600]};
          background-color: ${({ theme }) => theme.colors.green[600]};
        }
      }
    }
  }
`

export default StyledPassword
